<template>
  <div class="card-actions action-visit-slot-choice">
    <div
      class="card-actions__content"
    >
      <validate-future-slot
        v-if="askConfirmation"
        :interlocutor="interlocutor"
      />
      <div
        v-show="!askConfirmation"
        ref="slot"
        class="action-visit-slot-choice__content"
      >
        <schedule-slot
          :required="true"
          @changed="onDatetimeChanged"
          @datepicker-opened="onScheduleSlotDisplay(true)"
          @datepicker-closed="onScheduleSlotDisplay(false)"
          @timeslot-opened="onScheduleSlotDisplay(true)"
          @timeslot-closed="onScheduleSlotDisplay(false)"
        />
      </div>
    </div>
    <div class="card-actions__cta card-actions__cta--bottom visit-slot-choice-ctas">
      <div
        v-if="askConfirmation"
        class="input-checkbox do-not-show-again"
      >
        <input
          v-model="doNotShowAgain"
          type="checkbox"
          value="1"
        >
        <label
          for="doNotShowAgain"
          @click="doNotShowAgain = !doNotShowAgain"
        >
          {{ trans('global.do_not_show_message_again') }}
        </label>
      </div>
      <div class="visit-slot-choice-ctas__buttons">
        <button class="btn btn--secondary btn--cancel" @click="onCancelClick">
          {{ trans('deal_dashboard.action.visit.slot_choice.cancel') }}
        </button>
        <button
          class="btn btn--primary"
          :class="{ 'loading-btn': loading }"
          :disabled="!isValidSchedule"
          @click="validate"
        >
          <span v-if="!loading">
            {{ trans('deal_dashboard.action.visit.slot_choice.cta') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleSlot from '@components-molecules/ScheduleSlot.vue';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { URL_XHR_BUYER_DASHBOARD_VISIT_SLOT_CHOICE } from '@tools/routes/routes';
import { Logger } from '@tools/logger/logger';
import { momentMixin } from '@tools/moment';
import { requestsMixin } from '@tools/requests-mixin';
import ValidateFutureSlot from '@organisms/deal/ValidateFutureSlot.vue';
import { actionsMixins } from './actions-mixins';
import { EVENTS } from './constants';

export default {
  components: {
    ScheduleSlot, ValidateFutureSlot,
  },
  mixins: [ actionsMixins, momentMixin, requestsMixin ],
  props: {
    interlocutor: { type: Object, required: true },
  },
  data() {
    return {
      title: this.trans('deal_dashboard.action.visit.slot_choice.title'),
      loading: false,
      schedule: null,
      askConfirmation: false,
      doNotShowAgain: false,
      displayConfirmation: false,
    };
  },
  computed: {
    slot() {
      const slot = new Date(this.schedule.schedule.date);
      slot.setHours(this.schedule.schedule.time.HH);
      slot.setMinutes(this.schedule.schedule.time.mm);
      slot.setSeconds(0);
      return slot;
    },
    isValidSchedule() {
      return this.schedule !== null && this.schedule.isSlotValid;
    },
  },
  mounted() {
    this.$emit(EVENTS.TITLE_UPDATE, this.title);
    this.displayConfirmation = !window.initialDealDashboardDealsState?.do_not_show_validation;
    if (!this.displayConfirmation) {
      this.doNotShowAgain = true;
    }
  },
  methods: {
    onDatetimeChanged(schedule) {
      this.schedule = schedule;
      this.onScheduleSlotDisplay(null);
    },
    onScheduleSlotDisplay(force) {
      const flag = force || !this.schedule?.schedule;
      this.$refs.slot.classList.toggle('give-schedule-slot-some-space', flag);
      this.$refs.slot.classList.toggle('remove-schedule-slot-space', !flag);
    },
    onCancelClick() {
      if (this.askConfirmation) {
        this.askConfirmation = false;
        return;
      }
      this.$emit(EVENTS.ACTION_CANCELLED);
    },
    validate() {
      if (this.displayConfirmation && !this.askConfirmation && !this.isBefore(this.slot, new Date())) {
        this.askConfirmation = true;
        return;
      }
      this.submitChoice();
    },
    async submitChoice() {
      if (!window.initialDealDashboardDealsState) {
        window.initialDealDashboardDealsState = {};
      }
      window.initialDealDashboardDealsState.do_not_show_validation = this.doNotShowAgain;
      this.loading = true;
      const visitData = {
        date: this.getIsoWithLocalTimezone(this.slot),
        deal: this.deal,
        doNotShowValidationAgain: this.doNotShowAgain,
      };
      let response = null;
      try {
        response = await this.post(
          URL_XHR_BUYER_DASHBOARD_VISIT_SLOT_CHOICE.replace('{id}', this.deal.id),
          visitData,
        );
      } catch (error) {
        Logger.error(error);
      }
      this.loading = false;
      if (response && response.status === 204) {
        flashBagSuccess(this.trans('deal_dashboard.action.success'));
        this.$emit(EVENTS.ACTION_PERFORMED, null, { visitDate: visitData.date });
        return;
      }
      flashBagError(this.trans('deal_dashboard.action.failure'));
    },
  },
};
</script>
